import React from 'react';
import { Box, Switch, Tooltip } from '@mui/material';
import { useUserContext } from '../../../context_providers/user_context/UserProvider';
import { useHistory } from 'react-router-dom';
import BearerTokenCopier from './BearerTokenCopier';

const SwitchViewBanner = () => {
  const { setSafeguardView, safeguardView } = useUserContext();
  const history = useHistory();
  const { isSafeguardDev } = useUserContext();

  const handleSwitchChange = () => {
    setSafeguardView(!safeguardView);
    history.push(`/`);
  };

  return (
    <Box
      sx={{
        px: 1,
        py: 0.5,
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'end',
      }}
    >
      {isSafeguardDev && <BearerTokenCopier />}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <Box
          sx={{
            fontSize: '0.85rem',
            fontWeight: safeguardView ? 'bold' : 'normal',
            color: safeguardView ? 'orange' : 'grey.700',
            mr: 0.5,
          }}
        >
          SG
        </Box>
        <Tooltip
          title={
            safeguardView
              ? 'Switch to User Facing UI'
              : 'Switch to Safeguard Tooling'
          }
          arrow
        >
          <Switch
            checked={!safeguardView}
            onChange={handleSwitchChange}
            color="warning"
            size="small"
            inputProps={{ 'aria-label': 'toggle safeguard/user view' }}
          />
        </Tooltip>
        <Box
          sx={{
            fontSize: '0.85rem',
            fontWeight: !safeguardView ? 'bold' : 'normal',
            color: !safeguardView ? 'orange' : 'grey.700',
            ml: 0.5,
          }}
        >
          User
        </Box>
      </Box>
    </Box>
  );
};

export default SwitchViewBanner;
